import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Container, FilterChip, RemoveButton, ClearAllButton } from './ActiveFiltersIndicator.styled';
import { getCurrencySymbol } from '../../../../lib/formatCurrency';

const getSeasonKey = (name) => ({ summer: 'summer', winter: 'winter', 'all season': 'allSeason', 'all-season': 'allSeason' }[name?.toLowerCase()] || name);

const ActiveFiltersIndicator = ({
  seasonFilters,
  brandFilters,
  minPrice,
  maxPrice,
  searchOnlyInStock,
  onRemoveSeason,
  onRemoveBrand,
  onClearPrice,
  onClearInStock,
  onClearAll,
}) => {
  const { t } = useTranslation();
  
  const selectedSeasons = seasonFilters.filter((s) => s.selected);
  const selectedBrands = brandFilters.filter((b) => b.selected);
  const hasFilters = selectedSeasons.length > 0 || selectedBrands.length > 0 || minPrice || maxPrice || searchOnlyInStock;

  if (!hasFilters) return null;

  return (
    <Container>
      {selectedSeasons.map((s) => (
        <FilterChip key={s.id}>
          <i className={`mdi mdi-${s.icon}`} />
          {t(getSeasonKey(s.name))}
          <RemoveButton onClick={() => onRemoveSeason(s.id)} title={t('removeFilter')}>
            <i className="mdi mdi-close" />
          </RemoveButton>
        </FilterChip>
      ))}
      
      {selectedBrands.map((b) => (
        <FilterChip key={b.value}>
          <i className="mdi mdi-tag" />
          {b.label}
          <RemoveButton onClick={() => onRemoveBrand(b.value)} title={t('removeFilter')}>
            <i className="mdi mdi-close" />
          </RemoveButton>
        </FilterChip>
      ))}
      
      {(minPrice || maxPrice) && (
        <FilterChip>
          <i className="mdi mdi-cash" />
          {minPrice || '0'} - {maxPrice || '∞'} {getCurrencySymbol()}
          <RemoveButton onClick={onClearPrice} title={t('removeFilter')}>
            <i className="mdi mdi-close" />
          </RemoveButton>
        </FilterChip>
      )}
      
      {searchOnlyInStock && (
        <FilterChip>
          <i className="mdi mdi-package-variant" />
          {t('onlyInStock')}
          <RemoveButton onClick={onClearInStock} title={t('removeFilter')}>
            <i className="mdi mdi-close" />
          </RemoveButton>
        </FilterChip>
      )}
      
      <ClearAllButton onClick={onClearAll}>
        <i className="mdi mdi-close-circle" />
        {t('clearAll')}
      </ClearAllButton>
    </Container>
  );
};

ActiveFiltersIndicator.propTypes = {
  seasonFilters: PropTypes.array.isRequired,
  brandFilters: PropTypes.array.isRequired,
  minPrice: PropTypes.string,
  maxPrice: PropTypes.string,
  searchOnlyInStock: PropTypes.bool,
  onRemoveSeason: PropTypes.func.isRequired,
  onRemoveBrand: PropTypes.func.isRequired,
  onClearPrice: PropTypes.func.isRequired,
  onClearInStock: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
};

export default ActiveFiltersIndicator;

